import { useEffect } from "react";
import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/sections/HeroSection";
import EventsSection from "@/components/sections/EventsSection";
import { Seo } from "@/components/Seo";

const Arrangementer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title="Arrangementer – Håp Naturlab"
        description="Se kommende arrangementer fra Håp Naturlab – gründertreff, verksteder, rådgivning og mer."
        path="arrangementer"
      />
      <HeroSection
        heading="Våre arrangementer"
        body="Bli med på inspirerende samlinger, verksteder og treff. Her finner du alt som skjer hos Håp Naturlab."
        image="/images/hero-arrangementer.jpg"
        cta={[]}
      />
      <EventsSection
        heading="Kommende arrangementer"
        emptyMessage="Det er ingen arrangementer akkurat nå. Følg oss på Facebook eller meld deg som fast giver for å få beskjed når noe nytt kommer."
      />
    </Layout>
  );
};

export default Arrangementer;
